import { useState } from 'react';
import { WbLogoutConfirmDialog } from '../../WbLogoutConfirmDialog';
import { WbSidebarItem, WbSidebarSubmenuItem } from '../..';
import { LogoutIcon } from '../../../icons';
import { useWbSidebarMobileState } from '../WbNavbarMobileStateContext';

export const WbLogoutButton = ({ submenu = false }) => {
  const { isMobile } = useWbSidebarMobileState();

  const [openConfirm, setOpenConfirm] = useState(false);
  return (
    <>
      {submenu ? (
        <WbSidebarSubmenuItem
          closeMenu={!isMobile}
          onClick={() => setOpenConfirm(true)}
          icon={LogoutIcon}
          title="Log out"
        />
      ) : (
        <WbSidebarItem
          closeMenu={!isMobile}
          onClick={() => setOpenConfirm(true)}
          icon={LogoutIcon}
          text="Log out"
        />
      )}
      <WbLogoutConfirmDialog
        open={openConfirm}
        onClose={() => setOpenConfirm(false)}
      />
    </>
  );
};
